import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { SectionHeading } from "../shared/Section";
import useStore from "../shared/useStore";

const paths = [
  "M85 3.4V0l-3.4-1.5e-7V3.4H85zM85 6.80002v-3.4h-3.4v3.4H85zM85 10.2V6.80002h-3.4V10.2H85zM85 13.6v-3.4h-3.4v3.4H85zM85 17v-3.4h-3.4V17H85zM85 20.4V17h-3.4v3.4H85zM85 23.8v-3.4h-3.4v3.4H85zM85 30.6v-3.4h-3.4v3.4H85zM85 37.4V34h-3.4v3.4H85zM85 40.8v-3.4h-3.4v3.4H85zM85 44.2v-3.4h-3.4v3.4H85zM85 51v-3.4h-3.4V51H85zM85 64.6v-3.4h-3.4v3.4H85zM85 68v-3.4h-3.4V68H85zM85 71.4V68h-3.4v3.4H85z",
  "M85 74.8v-3.4h-3.4v3.4H85zM85 78.2v-3.4h-3.4v3.4H85z",
  "M85 81.6v-3.4h-3.4v3.4H85zM85 85v-3.4h-3.4V85H85zM81.6001 3.4V0l-3.4-1.5e-7V3.4h3.4zM81.6001 23.8v-3.4h-3.4v3.4h3.4zM81.6001 34v-3.4h-3.4V34h3.4zM81.6001 37.4V34h-3.4v3.4h3.4zM81.6001 44.2v-3.4h-3.4v3.4h3.4zM81.6001 47.6v-3.4h-3.4v3.4h3.4zM81.6001 57.8v-3.4h-3.4v3.4h3.4zM81.6001 64.6v-3.4h-3.4v3.4h3.4z",
  "M81.6001 85v-3.4h-3.4V85h3.4zM78.2 3.4V0l-3.4001-1.5e-7V3.4H78.2zM78.2 10.2V6.80002h-3.4001V10.2H78.2zM78.2 13.6v-3.4h-3.4001v3.4H78.2zM78.2 17v-3.4h-3.4001V17H78.2zM78.2 23.8v-3.4h-3.4001v3.4H78.2zM78.2 37.4V34h-3.4l-.0001 3.4H78.2zM78.2 40.8v-3.4h-3.4001v3.4H78.2zM78.2 44.2v-3.4h-3.4001v3.4H78.2zM78.2 47.6v-3.4h-3.4001v3.4H78.2zM78.2 54.4V51h-3.4001v3.4H78.2zM78.2 57.8v-3.4h-3.4001v3.4H78.2zM78.2 64.6v-3.4h-3.4001v3.4H78.2zM78.2 71.4V68h-3.4001v3.4H78.2z",
  "M78.2 74.8v-3.4h-3.4l-.0001 3.4H78.2zM78.2 78.2v-3.4h-3.4l-.0001 3.4H78.2zM78.2 85v-3.4h-3.4001V85H78.2zM74.8 3.4V0l-3.3999-1.5e-7V3.4H74.8zM74.8 10.2V6.80002h-3.3999V10.2H74.8zM74.8 13.6v-3.4h-3.3999v3.4H74.8zM74.8 17v-3.4h-3.3999V17H74.8zM74.8 23.8v-3.4h-3.3999v3.4H74.8zM74.8 47.6v-3.4h-3.3999v3.4H74.8zM74.8 54.4V51h-3.3999v3.4H74.8zM74.8 57.8v-3.4h-3.3999v3.4H74.8zM74.8 64.6v-3.4h-3.3999v3.4H74.8z",
  "M74.8 71.4V68h-3.3999v3.4H74.8z",
  "M74.8 74.8v-3.4h-3.4v3.4h3.4zM74.8 78.2v-3.4h-3.4v3.4h3.4zM74.8 85v-3.4h-3.4V85h3.4zM71.3999 3.4V0l-3.4-1.5e-7V3.4h3.4zM71.3999 10.2V6.80002h-3.4V10.2h3.4zM71.3999 13.6v-3.4h-3.4v3.4h3.4zM71.3999 17v-3.4h-3.4V17h3.4zM71.3999 23.8v-3.4h-3.4v3.4h3.4zM71.3999 34v-3.4h-3.4V34h3.4zM71.3999 47.6v-3.4h-3.4v3.4h3.4zM71.3999 51v-3.4h-3.4V51h3.4zM71.3999 57.8v-3.4h-3.4v3.4h3.4zM71.3999 64.6v-3.4h-3.4v3.4h3.4zM71.3999 71.4V68h-3.4v3.4h3.4z",
  "M71.3999 74.8v-3.4h-3.4v3.4h3.4zM71.3999 78.2v-3.4h-3.4v3.4h3.4zM71.3999 85v-3.4h-3.4V85h3.4zM68 3.4V0l-3.4-1.5e-7V3.4H68zM68 23.8v-3.4h-3.4v3.4H68zM68 37.4V34h-3.4v3.4H68zM68 40.8v-3.4h-3.4v3.4H68zM68 51v-3.4h-3.4V51H68zM68 64.6v-3.4h-3.4v3.4H68z",
  "M68 85v-3.4h-3.4V85H68zM64.6001 3.4V0l-3.4-1.5e-7V3.4h3.4zM64.6001 6.80002v-3.4h-3.4v3.4h3.4zM64.6001 10.2V6.80002h-3.4V10.2h3.4zM64.6001 13.6v-3.4h-3.4v3.4h3.4zM64.6001 17v-3.4h-3.4V17h3.4zM64.6001 20.4V17h-3.4v3.4h3.4zM64.6001 23.8v-3.4h-3.4v3.4h3.4zM64.6001 30.6v-3.4h-3.4v3.4h3.4zM64.6001 37.4V34h-3.4v3.4h3.4zM64.6001 44.2v-3.4h-3.4v3.4h3.4zM64.6001 51v-3.4h-3.4V51h3.4zM64.6001 57.8v-3.4h-3.4v3.4h3.4zM64.6001 64.6v-3.4h-3.4v3.4h3.4zM64.6001 68v-3.4h-3.4V68h3.4zM64.6001 71.4V68h-3.4v3.4h3.4z",
  "M64.6001 74.8v-3.4h-3.4v3.4h3.4zM64.6001 78.2v-3.4h-3.4v3.4h3.4z",
  "M64.6001 81.6v-3.4h-3.4v3.4h3.4zM64.6001 85v-3.4h-3.4V85h3.4zM61.2 30.6v-3.4h-3.4v3.4h3.4zM61.2 37.4V34h-3.4v3.4h3.4zM61.2 44.2v-3.4h-3.4v3.4h3.4zM61.2 47.6v-3.4h-3.4v3.4h3.4zM61.2 57.8v-3.4h-3.4v3.4h3.4zM57.8 3.4V0l-3.4-1.5e-7V3.4h3.4zM57.8 6.80002v-3.4h-3.4v3.4h3.4zM57.8 13.6v-3.4h-3.4v3.4h3.4zM57.8 17v-3.4h-3.4V17h3.4zM57.8 23.8v-3.4h-3.4v3.4h3.4zM57.8 34v-3.4h-3.4V34h3.4zM57.8 37.4V34h-3.4v3.4h3.4zM57.8 51v-3.4h-3.4V51h3.4zM57.8 54.4V51h-3.4v3.4h3.4zM57.8 64.6v-3.4h-3.4v3.4h3.4zM57.8 85v-3.4h-3.4V85h3.4zM54.3999 3.4V0l-3.4-1.5e-7V3.4h3.4zM54.3999 6.80002v-3.4h-3.4v3.4h3.4zM54.3999 10.2V6.80002h-3.4V10.2h3.4zM54.3999 13.6v-3.4h-3.4v3.4h3.4zM54.3999 17v-3.4h-3.4V17h3.4zM54.3999 20.4V17h-3.4v3.4h3.4zM54.3999 27.2v-3.4h-3.4v3.4h3.4zM54.3999 30.6v-3.4h-3.4v3.4h3.4zM54.3999 34v-3.4h-3.4V34h3.4zM54.3999 40.8v-3.4h-3.4v3.4h3.4zM54.3999 51v-3.4h-3.4V51h3.4zM54.3999 54.4V51h-3.4v3.4h3.4zM54.3999 68v-3.4h-3.4V68h3.4zM54.3999 71.4V68h-3.4v3.4h3.4z",
  "M54.3999 74.8v-3.4h-3.4v3.4h3.4zM54.3999 78.2v-3.4h-3.4v3.4h3.4z",
  "M54.3999 81.6v-3.4h-3.4v3.4h3.4zM51 3.4V0l-3.4-1.5e-7V3.4H51zM51 13.6v-3.4h-3.4v3.4H51zM51 23.8v-3.4h-3.4v3.4H51zM51 37.4V34h-3.4v3.4H51zM51 40.8v-3.4h-3.4v3.4H51zM51 51v-3.4h-3.4V51H51zM51 54.4V51h-3.4v3.4H51zM51 57.8v-3.4h-3.4v3.4H51zM51 71.4V68h-3.4v3.4H51z",
  "M51 74.8v-3.4h-3.4v3.4H51zM51 85v-3.4h-3.4V85H51zM47.6001 6.80002v-3.4h-3.4v3.4h3.4zM47.6001 10.2V6.80005h-3.4V10.2h3.4zM47.6001 13.6v-3.4h-3.4v3.4h3.4zM47.6001 17v-3.4h-3.4V17h3.4zM47.6001 27.2v-3.4h-3.4v3.4h3.4zM47.6001 30.6v-3.4h-3.4v3.4h3.4zM47.6001 34v-3.4h-3.4V34h3.4zM47.6001 37.4V34h-3.4v3.4h3.4zM47.6001 51v-3.4h-3.4V51h3.4zM47.6001 54.4V51h-3.4v3.4h3.4zM47.6001 68v-3.4h-3.4V68h3.4z",
  "M47.6001 74.8v-3.4h-3.4v3.4h3.4zM47.6001 78.2v-3.4h-3.4v3.4h3.4z",
  "M47.6001 81.6v-3.4h-3.4v3.4h3.4zM47.6001 85v-3.4h-3.4V85h3.4zM44.2 13.6v-3.4h-3.4v3.4h3.4zM44.2 17v-3.4h-3.4V17h3.4zM44.2 23.8v-3.4h-3.4v3.4h3.4zM44.2 27.2v-3.4h-3.4v3.4h3.4zM44.2 30.6v-3.4h-3.4v3.4h3.4zM44.2 34v-3.4h-3.4V34h3.4zM44.2 44.2v-3.4h-3.4v3.4h3.4zM44.2 54.4V51h-3.4v3.4h3.4zM44.2 57.8v-3.4h-3.4v3.4h3.4zM44.2 64.5999V61.2h-3.4v3.3999h3.4zM44.2 68v-3.4h-3.4V68h3.4zM44.2 85v-3.4h-3.4V85h3.4zM40.8 3.4V0l-3.4-1.5e-7V3.4h3.4zM40.8 6.80002v-3.4h-3.4v3.4h3.4zM40.8 10.2V6.80002h-3.4V10.2h3.4zM40.8 17v-3.4h-3.4V17h3.4zM40.8 30.6v-3.4h-3.4v3.4h3.4zM40.8 34v-3.4h-3.4V34h3.4zM40.8 40.8v-3.4h-3.4v3.4h3.4zM40.8 44.2v-3.4h-3.4v3.4h3.4zM40.8 51v-3.4h-3.4V51h3.4zM40.8 54.4V51h-3.4v3.4h3.4zM40.8 57.8v-3.4h-3.4v3.4h3.4zM40.8 61.2v-3.4h-3.4v3.4h3.4zM40.8 71.4V68h-3.4v3.4h3.4zM40.8 81.6v-3.4h-3.4v3.4h3.4zM37.3999 3.4V0l-3.4-1.5e-7V3.4h3.4zM37.3999 6.80002v-3.4h-3.4v3.4h3.4zM37.3999 17v-3.4h-3.4V17h3.4zM37.3999 20.4V17h-3.4v3.4h3.4zM37.3999 23.8v-3.4h-3.4v3.4h3.4zM37.3999 34v-3.4h-3.4V34h3.4zM37.3999 47.6v-3.4h-3.4v3.4h3.4zM37.3999 54.4V51h-3.4v3.4h3.4zM37.3999 57.8v-3.4h-3.4v3.4h3.4zM37.3999 64.6v-3.4h-3.4v3.4h3.4zM37.3999 71.4V68h-3.4v3.4h3.4z",
  "M37.3999 74.8v-3.4h-3.4v3.4h3.4zM37.3999 78.2v-3.4h-3.4v3.4h3.4z",
  "M37.3999 81.6v-3.4h-3.4v3.4h3.4zM37.3999 85v-3.4h-3.4V85h3.4zM34 3.4V0l-3.4-1.5e-7V3.4H34zM34 10.2V6.80002h-3.4V10.2H34zM34 13.6v-3.4h-3.4v3.4H34zM34 17v-3.4h-3.4V17H34zM34 20.4V17h-3.4v3.4H34zM34 27.2v-3.4h-3.4v3.4H34zM34 30.6v-3.4h-3.4v3.4H34zM34 54.4V51h-3.4v3.4H34zM34 68v-3.4h-3.4V68H34zM34 74.8v-3.4h-3.4v3.4H34z",
  "M34 78.2v-3.4h-3.4v3.4H34zM34 85v-3.4h-3.4V85H34zM30.6001 3.4V0l-3.4-1.5e-7V3.4h3.4zM30.6001 23.8v-3.4h-3.4v3.4h3.4zM30.6001 37.4V34h-3.4v3.4h3.4zM30.6001 44.2v-3.4h-3.4v3.4h3.4zM30.6001 47.6v-3.4h-3.4v3.4h3.4zM30.6001 57.8v-3.4h-3.4v3.4h3.4zM30.6001 61.2v-3.4h-3.4v3.4h3.4z",
  "M30.6001 64.6v-3.4h-3.4v3.4h3.4zM30.6001 68v-3.4h-3.4V68h3.4zM30.6001 71.4V68h-3.4v3.4h3.4zM30.6001 78.2v-3.4h-3.4v3.4h3.4z",
  "M30.6001 81.6v-3.4h-3.4v3.4h3.4zM27.2 30.6v-3.4h-3.4v3.4h3.4zM27.2 47.6v-3.4h-3.4v3.4h3.4zM27.2 57.8v-3.4h-3.4v3.4h3.4zM27.2 71.4V68h-3.4v3.4h3.4zM27.2 78.2v-3.4h-3.4v3.4h3.4z",
  "M27.2 81.6v-3.4h-3.4v3.4h3.4zM23.8 3.4V0l-3.4-1.5e-7V3.4h3.4zM23.8 6.80002v-3.4h-3.4v3.4h3.4zM23.8 10.2V6.80002h-3.4V10.2h3.4zM23.8 13.6v-3.4h-3.4v3.4h3.4zM23.8 17v-3.4h-3.4V17h3.4zM23.8 20.4V17h-3.4v3.4h3.4zM23.8 23.8v-3.4h-3.4v3.4h3.4zM23.8 40.8v-3.4h-3.4v3.4h3.4zM23.8 57.8v-3.4h-3.4v3.4h3.4zM23.8 64.6v-3.4h-3.4v3.4h3.4zM23.8 71.4V68h-3.4v3.4h3.4zM23.8 85v-3.4h-3.4V85h3.4zM20.3999 3.4V0l-3.4-1.5e-7V3.4h3.4zM20.3999 23.8v-3.4h-3.4v3.4h3.4zM20.3999 37.4V34h-3.4v3.4h3.4zM20.3999 40.8v-3.4h-3.4v3.4h3.4zM20.3999 47.6v-3.4h-3.4v3.4h3.4zM20.3999 51v-3.4h-3.4V51h3.4zM20.3999 54.4V51h-3.4v3.4h3.4zM20.3999 57.8v-3.4h-3.4v3.4h3.4zM20.3999 71.4V68h-3.4v3.4h3.4zM20.3999 81.6v-3.4h-3.4v3.4h3.4zM20.3999 85v-3.4h-3.4V85h3.4z",
  "M17 3.4V0l-3.4-1.5e-7V3.4H17zM17 10.2V6.80002h-3.4V10.2H17zM17 13.6v-3.4h-3.4v3.4H17zM17 17v-3.4h-3.4V17H17zM17 23.8v-3.4h-3.4v3.4H17zM17 30.6v-3.4h-3.4v3.4H17zM17 34v-3.4h-3.4V34H17zM17 37.4V34h-3.4v3.4H17zM17 40.8v-3.4h-3.4v3.4H17zM17 44.2v-3.4h-3.4v3.4H17zM17 54.4V51h-3.4v3.4H17zM17 57.8v-3.4h-3.4v3.4H17zM17 61.2v-3.4h-3.4v3.4H17z",
  "M17 64.6v-3.4h-3.4v3.4H17zM17 68v-3.4h-3.4V68H17zM17 71.4V68h-3.4v3.4H17zM17 81.6v-3.4h-3.4v3.4H17zM13.6001 3.4V0l-3.4-1.5e-7V3.4h3.4zM13.6001 10.2V6.80002h-3.4V10.2h3.4zM13.6001 13.6v-3.4h-3.4v3.4h3.4zM13.6001 17v-3.4h-3.4V17h3.4zM13.6001 23.8v-3.4h-3.4v3.4h3.4zM13.6001 30.6v-3.4h-3.4v3.4h3.4zM13.6001 34v-3.4h-3.4V34h3.4zM13.6001 37.4V34h-3.4v3.4h3.4zM13.6001 40.8v-3.4h-3.4v3.4h3.4zM13.6001 47.6v-3.4h-3.4v3.4h3.4zM13.6001 51v-3.4h-3.4V51h3.4zM13.6001 54.4V51h-3.4v3.4h3.4zM13.6001 57.8v-3.4h-3.4v3.4h3.4z",
  "M13.6001 61.2v-3.4h-3.4v3.4h3.4z",
  "M13.6001 64.6v-3.4h-3.4v3.4h3.4zM13.6001 81.6v-3.4h-3.4v3.4h3.4zM13.6001 85v-3.4h-3.4V85h3.4zM10.2 3.4V0L6.79995-1.5e-7V3.4H10.2zM10.2 10.2V6.80002H6.79995V10.2H10.2zM10.2 13.6v-3.4H6.79995v3.4H10.2zM10.2 17v-3.4H6.79995V17H10.2zM10.2 23.8v-3.4H6.79995v3.4H10.2zM10.2 34v-3.4H6.79995V34H10.2zM10.2 37.4V34H6.79995v3.4H10.2zM10.2 40.8v-3.4H6.79995v3.4H10.2zM10.2 47.6v-3.4H6.79995v3.4H10.2zM10.2 54.4V51H6.79995v3.4H10.2zM10.2 61.2v-3.4H6.79995v3.4H10.2zM10.2 71.4V68H6.79995v3.4H10.2z",
  "M10.2 74.8v-3.4H6.79995v3.4H10.2zM10.2 78.2v-3.4H6.79995v3.4H10.2z",
  "M10.2 81.6v-3.4H6.79995v3.4H10.2zM10.2 85v-3.4H6.79995V85H10.2zM6.80005 3.4V0L3.40004-1.5e-7V3.4h3.40001zM6.80005 23.8v-3.4H3.40004v3.4h3.40001zM6.80005 30.6v-3.4H3.40004v3.4h3.40001zM6.80005 34v-3.4H3.40004V34h3.40001zM6.80005 37.4V34H3.40004v3.4h3.40001zM6.80005 44.2v-3.4H3.40004v3.4h3.40001zM6.80005 61.2v-3.4H3.40004v3.4h3.40001zM6.80005 68v-3.4H3.40004V68h3.40001zM6.80005 71.4V68h-3.4v3.4h3.4z",
  "M6.80005 78.2v-3.4h-3.4v3.4h3.4z",
  "M6.80005 81.6v-3.4h-3.4v3.4h3.4zM6.80005 85v-3.4h-3.4V85h3.4zM3.3999 3.4V0L-.0000918-1.5e-7-.00009193 3.4H3.3999zM3.3999 6.80002v-3.4H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 10.2V6.80002H-.0000918l-1.4e-7 3.39998H3.3999zM3.3999 13.6v-3.4H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 17v-3.4H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 20.4V17H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 23.8v-3.4H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 30.6v-3.4H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 40.8v-3.4H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 44.2v-3.4H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 57.8v-3.4H-.0000918l-1.4e-7 3.4H3.3999zM3.3999 64.6v-3.4H-.00009918l-1.5e-7 3.4H3.3999zM3.3999 74.8v-3.4H-.00009918l-1.5e-7 3.4H3.3999zM3.3999 85v-3.4H-.00009918l-1.5e-7 3.4H3.3999z",
];

const animationDelay = 3000;

const fade = keyframes`
  to {
    opacity: 0;
  }
`;

const CodeWrapper = styled.div`
  opacity: 1;
  background-color: #644ed1;
  animation: ${fade} 1s ${animationDelay + 2000}ms forwards;
  position: absolute;
  top: 30px;
  right: 30px;
`;

const Code = ({ fill = "#ffffff" }) => (
  <CodeWrapper>
    <svg
      viewBox="0 0 85 85"
      width="85"
      height="85"
      xmlns="http://www.w3.org/2000/svg"
      fill="#644ed1"
    >
      <g clipPath="url(#clip0)" fill={fill}>
        {paths.map((path, index) => (
          <path index={index} key={index} d={path} />
        ))}
      </g>
      <defs>
        <clipPath id="clip0">
          <path
            fill={fill}
            transform="rotate(90 42.5 42.5)"
            d="M0 0h85v85H0z"
          />
        </clipPath>
      </defs>
    </svg>
  </CodeWrapper>
);

const slideIn = keyframes`
  to {
    transform: rotate(10deg) translate(0px, 0px);
  }
`;

const zoomIn = keyframes`
  99% {
    opacity: 1;
    transform: rotate(0deg) scale(40);
  }
  to {
    opacity: 0;
    transform: none;
  }
`;

const CardContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 340px;
  height: 540px;
  transform: translate(-50%, -50%);
  @media (${(props) => props.theme.breakpoint}) {
    transform: translate(-50%, -50%) scale(0.5);
  }
  transition: opacity 400ms;
`;

const Card = styled.div`
  position: absolute;
  width: 340px;
  height: 540px;
  box-shadow: 0 6px 24px rgba(173, 156, 255, 0.3),
    0 4px 12px rgba(173, 156, 255, 0.22);
  animation: ${slideIn} 1s ease-out ${animationDelay}ms forwards,
    ${zoomIn} 2s ease-in ${animationDelay + 3000}ms forwards;
  transform: rotate(20deg) translate(-100vw, 20vh);
  @media (${(props) => props.theme.breakpoint}) {
    transform: rotate(20deg) translate(-200vw, 20vh);
  }
  transform-origin: 280px 45px;
  will-change: transform;
  p {
    z-index: 2;
    position: absolute;
    bottom: 0px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    padding: 30px;
    font-size: 1.2rem;
    font-weight: 700;
    &::before {
      content: "";
      position: absolute;
      top: -10px;
      left: 30px;
      height: 3px;
      width: 30px;
      background-color: #fff;
    }
  }
`;

const CardMask = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 340 540"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M340 0H0V540H340V0ZM310 30H225V115H310V30Z"
      fill="#644ED1"
    />
  </svg>
);

const TopMask = styled.div`
  position: absolute;
  bottom: 510px;
  left: 0;
  width: 100vw;
  @media (${(props) => props.theme.breakpoint}) {
    width: 200vw;
    height: 200vh;
  }
  height: 100vh;
  background-color: #000;
  z-index: -1;
  display: none;
  opacity: 0;
  transition: opacity 200ms;
  &::before {
    content: "";
    position: absolute;
    top: 90vh;
    left: 310px;
    width: 100vw;
    height: 100vh;
    @media (${(props) => props.theme.breakpoint}) {
      top: 190vh;
      width: 200vw;
      height: 200vh;
    }
    background-color: #000;
  }
`;

const BottomMask = styled.div`
  position: absolute;
  top: 116px;
  right: 0;
  width: 100vw;
  height: 100vh;
  @media (${(props) => props.theme.breakpoint}) {
    width: 200vw;
    height: 200vh;
  }
  background-color: #000;
  z-index: -1;
  display: none;
  opacity: 0;
  transition: opacity 200ms;
  transition-delay: 100ms;
  &::before {
    content: "";
    position: absolute;
    bottom: 90vh;
    right: 116px;
    width: 100vw;
    height: 100vh;
    @media (${(props) => props.theme.breakpoint}) {
      bottom: 190vh;
      width: 200vw;
      height: 200vh;
    }
    background-color: #000;
  }
`;

const BusinessCard = () => {
  const updateProgress = useStore((state) => state.updateProgress);

  const topMaskRef = useRef();
  const bottomMaskRef = useRef();
  const container = useRef();

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      topMaskRef.current.style = "display: block; opacity: 1;";
      bottomMaskRef.current.style = "display: block; opacity: 1;";
    }, animationDelay + 1000);
    const timeout2 = window.setTimeout(() => {
      container.current.style = "opacity: 0";
    }, animationDelay + 3800);
    const timeout3 = window.setTimeout(() => {
      container.current.style = "display:none; opacity: 0";
      updateProgress({ ready: true });
    }, animationDelay + 3900);
    return () => {
      window.clearTimeout(timeout);
      window.clearTimeout(timeout2);
      window.clearTimeout(timeout3);
    };
  });

  return (
    <CardContainer ref={container}>
      <Card>
        <TopMask ref={topMaskRef} />
        <BottomMask ref={bottomMaskRef} />
        <Code />
        <CardMask />
        <p>
          <span>
            Dorian
            <br />
            Guilmain
          </span>
          <span>001</span>
        </p>
      </Card>
    </CardContainer>
  );
};

const backgroundFadeOut = keyframes`
  to {
    background-color: transparent;
  }
`;

const disappear = keyframes`
  to {
    opacity: 0;
  }
`;

const Content = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  padding: 5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  animation: ${backgroundFadeOut} 1s ${animationDelay + 2000}ms forwards;
  z-index: 9998;
  overflow: hidden;
  pointer-events: none;
  h2 {
    animation: ${disappear} 1s ${animationDelay}ms forwards;
    text-align: center;
  }
`;

const QrCode = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [active, setActive] = useState(false);
  const updateProgress = useStore((state) => state.updateProgress);

  useEffect(() => {
    if (pathname !== "/qr") {
      updateProgress({ ready: true });
      setActive(false);
    }
  }, [pathname, updateProgress]);

  useEffect(() => {
    const unsubscribe = useStore.subscribe(
      (progress) => {
        if (progress.finished && !progress.ready && pathname === "/qr") {
          setActive(true);
        } else {
          setActive(false);
        }
      },
      (state) => state.progress
    );
    return () => {
      unsubscribe();
      setActive(false);
    };
  }, [pathname, updateProgress]);

  return active ? (
    <Content>
      <SectionHeading>{t("QrCode.title")}</SectionHeading>
      <BusinessCard />
    </Content>
  ) : null;
};

export default QrCode;
